module.exports = __webpack_public_path__ + "static/media/KebabMenu.493dd299.svg";